import {
  Box,
  Button,
  Card,
  CardContent,
  Container,
  LinearProgress,
  useMediaQuery,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { ArrowForward } from "@material-ui/icons";
import { FormBuilder } from "@zennya/web-component-library/src/components/FormBuilder";
import { ConcentricBadge } from "components/ConcentricBadge";
import { motion } from "framer-motion";
import { debounce, isEmpty } from "lodash";
import React, {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import { useHistory, useLocation } from "react-router-dom";
import { JsonParam, StringParam } from "serialize-query-params";
import locationsService from "services/locations.service";
import { BooleanParam, useQueryParam } from "use-query-params";
import {
  getBarangays,
  getCities,
  getProvince,
  getRegions,
} from "util/address/fetchAddressComponents";
import { slideRight, slideUp } from "util/transitions";
import * as Yup from "yup";
import { useStyles as baseCardStyles } from "../MedicalId/index";

import { useFormikContext } from "formik";
import { processHealthPass } from "util/ProcessHealthPass";
import { AutocompleteAddress } from "components/AutocompleteAddress";
const useStyles = makeStyles((theme) => ({}));

const formLayout = [
  ["civilStatus"],
  ['building_info', 'street'],
  "autocomplete",
  ["region", "province"],
  ["city", "barangay"]
];

function BasicInformation({loading}) {
  const classes = { ...useStyles(), ...baseCardStyles() };
  const history = useHistory();
  const location = useLocation();

  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("xs"), {
    noSsr: true,
  });

  const [urlFormValues, setUrlFormValues] = useQueryParam(
    "addressInfoForm",
    JsonParam
  );

  const [isDependent, setIsDependent]= useQueryParam("isDependent", BooleanParam);

  const [formValues, setFormValues] = useState(urlFormValues);

  const [address, setAddress] = useState();
  const [region, setRegion] = useState(urlFormValues?.region);
  const [province, setProvince] = useState(urlFormValues?.province);
  const [city, setCity] = useState(urlFormValues?.city);
  const [barangay, setBarangay] = useState(urlFormValues?.barangay);
  
  const [triggerReset, setTriggerReset] = useState(false);

  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("xs"));
  const backButtonProps = {
    variant: isSmallScreen ? "text" : "contained",
  };

  const debounceParams = useCallback(
    debounce(
      (values) => {
        setUrlFormValues(values, "replaceIn");
      },
      250,
      { maxWait: 500 }
    ),
    []
  );

  useEffect(() => {
    debounceParams(formValues);
  }, [debounceParams, formValues, setUrlFormValues]);


  const form = useMemo(() => {
    return {
      autocomplete: {
        type: 'component',
        component: () => (
          <AutocompleteAddress onSelectAddress={(value)=>{
            setAddress(value)}
          }/>
        ),
      },
      barangay: {
        type: "text",
        // readOnly: isEmpty(barangays),
        fieldProps: {
          className: formValues?.barangay ? classes.prefilled: classes.default
        },
        label: "Barangay",
        initialValues: formValues?.barangay ?? "",
        validator: () => Yup.string().required().nullable().label(" "),
      },
      province: {
        type: "text",
        // readOnly: isEmpty(provinces),
        fieldProps: {
          className: formValues?.province ? classes.prefilled: classes.default
        },
        label: "Province",
        initialValues: formValues?.province ?? "",
        validator: () => Yup.string().required().nullable().label(" "),
      },
      region: {
        type: "text",
        fieldProps: {
          className: formValues?.region ? classes.prefilled: classes.default
        },
        label: "Region",
        initialValues: formValues?.region ?? "",
        validator: () => Yup.string().required().nullable().label(" "),
      },
      city: {
        type: "text",
        // readOnly: isEmpty(cities),
        fieldProps: {
          className: formValues?.city ? classes.prefilled: classes.default
        },
        label: "City/Municipality",
        initialValues: formValues?.city ?? "",
        validator: () => Yup.string().required().nullable().label(" "),
      },
      street: {
        type: "text",
        label: "Street",
        initialValues: formValues?.street??"",
        fieldProps: {
          className: formValues?.street ? classes.prefilled: classes.default
        },
        validator: () => Yup.string().required().nullable().label(' '),
      },
      building_info: {
        type: "text",
        label: "House/Building Number",
        initialValues: formValues?.building_info??"",
        fieldProps: {
          className: formValues?.building_info ? classes.prefilled: classes.default
        },
        validator: () => Yup.string().required().nullable().label(' '),
      },
      civilStatus: {
        type: "select",
        label: "Civil Status",
        initialValues: formValues?.civilStatus ?? "",
        fieldProps: {
          className: formValues?.civilStatus ? classes.prefilled: classes.default
        },
        options: [
          { value: "SINGLE", label: "Single" },
          { value: "MARRIED", label: "Married" },
          { value: "WIDOW", label: "Widow/Widower" },
          { value: "SEPARATED", label: "Separated/Annuled" },
          { value: "LIVE_IN", label: "Living with Partner" },
        ],
        settings: {
          default: "",
          multiple: false,
          labelField: "label",
          valueField: "value",
        },
        validator: () => Yup.string().required().nullable().label(" "),
      },
    };
  }, [classes.default, classes.prefilled, formValues?.barangay, formValues?.building_info, formValues?.city, formValues?.civilStatus, formValues?.province, formValues?.region, formValues?.street]);

  async function handleSubmit() {
    console.log("📢[index.js:157]:", "handleSubmit");
    history.push({
      pathname: "/onboarding/medical2",
      search: location.search,
    });
  }

  const FormConsumer = (props) => {
    const {values, initialValues, setValues, setFieldValue, ...formik} = useFormikContext();
    
    useEffect(() => {
      const dirty = formik.dirty
      if (!isEmpty(address)) {
        setFieldValue('province', address?.province??"", true)
        setFieldValue('city', address?.city??"", true)
        setFieldValue('barangay', address?.barangay??"", true)
        setFieldValue('region', address?.region??"", true)
        setAddress()
      }
    }, [address, formik.dirty]);
    // useEffect(() => {
    //   if (isEmpty(provinces) && !loading && formik.dirty) {
    //     setFieldValue('province', '', false)
    //   }
    // }, [provinces, formik.dirty]);
    // useEffect(() => {
    //   if (isEmpty(cities) && !loading && formik.dirty) {
    //     setFieldValue('city', '', false)
    //   }
    // }, [cities, formik.dirty]);
    // useEffect(() => {
    //   if (isEmpty(barangays) && !loading && formik.dirty) {
    //     setFieldValue('barangay', '', false)
    //   }
    // }, [barangays, formik.dirty]);
    return null;
  };

  return (
  
      <Container fixed maxWidth="md" className={classes.cardInset}>
        <Box className={classes.headerContainer}>
          <ConcentricBadge number="3" />
          <span className={classes.header}>
            Additional Employee Information
          </span>
        </Box>
        <Card className={classes.card}>
          <CardContent>
            <FormBuilder
              formId="additionalEmployeeInfo"
              // usePersist
              onChange={(values) => {
                // if (values !== formValues) {
                setFormValues(values);
                // }
              }}
              // formProps={{
              //   enableReinitialize:true
              // }}
              variant="outlined"
              formLabel=" "
              submitLabel={
                <>
                  Next <ArrowForward fontSize="small" />
                </>
              }
              formFactor="default"
              hasReset={false}
              // setValues={formValues}
              formLayout={formLayout}
              form={form}
              onSubmit={(values) => {
                handleSubmit();
              }}
              additionalActions={() => (
                <Button {...backButtonProps} onClick={() => history.goBack()}>
                  Back
                </Button>
              )}
            >
              <FormConsumer />
            </FormBuilder>
          </CardContent>
        </Card>
      </Container>

  );
}

export default function BasicInformationLoader() {
  const [loading, setLoading] = useState(true);
  const [hashId, setHashId] = useQueryParam("code", StringParam);
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("xs"), {
    noSsr: true,
  });
  const [urlFormValues, setUrlFormValues] = useQueryParam(
    "addressInfoForm",
    JsonParam
  );
  const [isDependent, setIsDependent]= useQueryParam("isDependent", BooleanParam);

  useEffect(() => {
    async function fetchHealthPass() {
      const healthPass = await processHealthPass(hashId);
      if (isEmpty(urlFormValues)) {
        setUrlFormValues(healthPass?.addressInfoForm, "replaceIn");
        setIsDependent(healthPass?.dependentDetails?.isDependent, "replaceIn");
      }
      setLoading(false);
    }
    fetchHealthPass();
  }, [hashId, setIsDependent, setUrlFormValues, urlFormValues]);

  if (loading) {
    return <LinearProgress />;
  }
  return (
    <motion.div {...(isMobile ? slideRight : slideUp)}>
      <BasicInformation loading={loading}/>
    </motion.div>
  );
}
